import request from '@/utils/request'
import verificationJson from './mock/dealerInfo.json'
 
export function getFomrInfo(dealCd, entrRqstFomNo, opmkNo) {
    let params = {
        dealCd: dealCd,
        entrRqstFomNo: entrRqstFomNo,
        opmkNo: opmkNo
    }
    return request({
        url: `/ococ/datacapture/openmarket/getFormInfo`,
        method: 'get',
        params
    })  
}

// // 카드 인증
// export function xPayCardAuthcheck(reqData) {
//     let cardAuthInfo = {
//         lgdPan: reqData.lgdPan, // 카드 번호
//         lgdExpyear: reqData.lgdExpyear, // 카드 유효 년도
//         lgdExpmon: reqData.lgdExpmon, // 카드유효월
//         lgdBuyer: reqData.lgdBuyer, // 신청자
//         lgdPin: reqData.lgdPin, // 비밀번호 앞자리 2자리
//         lgdPrivateno: reqData.lgdPrivateno, // 주민번호 앞 6자리
//         dealCd: reqData.dealCd,   // 대리점코드
//         onetMblAppfNo: reqData.onetMblAppfNo // 신청서번호
//     }

//     return request({
//         url: `/ococ/datacapture/auth/xPayCardAuthcheck`,
//         method: 'post',
//         data: cardAuthInfo
//     })
// }

// // 범용 공인인증

// // 모바일 인증
// export function smsAuthSend(reqData) {
//     let mobileInfo = {
//         phoneNo: reqData.phoneNo,
//         dealId: reqData.dealCd,
//         onetMblAppfNo: reqData.onetMblAppfNo,
//         buyer: reqData.lgdBuyer,
//         birthDay: reqData.lgdPrivateno
//     }
//     return request({
//         url: `/ococ/datacapture/auth/smsAuthSend`,
//         method: 'post',
//         data: mobileInfo
//     })
// }
// // 모바일인증 결과체크 페이지
// export function smsAuthCheck(reqData) {
//     let mobileAuthInfo =  {
//         appfNo: reqData.onetMblAppfNo,
//         pAuthKey: reqData.pAuthKey
//     }
//     return request({
//         url: `/ococ/datacapture/auth/smsAuthSend`,
//         method: 'post',
//         data: mobileAuthInfo
//     })
// }

// export function normal